<template>
  <div class="Navbar">
    <nav class="navbar is-dark" role="navigation" aria-label="main navigation">

      <div id="navbarBasicExample" class="navbar-menu">
        <div class="navbar-brand">
        </div>
        <div class="navbar-end">
          <div class="navbar-item">
            <div class="columns" v-if="userStatus">
              <div class="column"><img style="vertical-align: bottom;font-size:22px;" v-bind:src="user.photoURL"/></div>
              <div class="column">{{user.providerData[0].displayName}}</div>
            </div>
          </div>
          <div class="navbar-item">
            
            <div class="buttons">
              <a class="button is-light" v-if="userStatus" @click="doLogout">
                <strong>Logout</strong>
              </a>
              <a class="button is-primary" v-if="!userStatus" @click="doLogin">
                <span class="icon">
                  <i class="fa fa-github" style="font-size: 25px"></i>
                </span><strong>Log in</strong>
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>
<script>
import Firebase from "./../firebase";
export default {
  created: function() {
    Firebase.onAuth();
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    userStatus() {
      // ログインするとtrue
      return this.$store.getters.isSignedIn;
    }
  },
  methods: {
    // ログイン処理
    async doLogin() {
      await Firebase.login();
      this.$buefy.dialog.alert("ログインしました");
    },
    // ログアウト処理
    doLogout() {
      Firebase.logout();
      this.$buefy.dialog.alert("ログアウトしました");
    }
  }
};
</script>>
<style scoped>
.Navbar {
  
}
</style>
